/**
 * Product Page Scroll Behavior
 * 
 * This script implements a "scroll right panel first" behavior for the product page.
 * When scrolling in either direction ANYWHERE on the page, the right panel will scroll completely
 * before allowing the page to scroll.
 * 
 * Mobile devices use a step-by-step navigation with buttons to access all options.
 */
document.addEventListener('DOMContentLoaded', function() {
  // Get the right side panel element
  const rightSidePanel = document.getElementById('rightSidePanel');
  
  // Check if we're on a mobile device
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;
  
  if (rightSidePanel && !isMobile) { // Only apply custom scrolling on desktop
    // Set initial state
    let isRightPanelScrolledToBottom = false;
    let isRightPanelScrolledToTop = false;
    
    // Check if right panel is scrolled to bottom or top
    function checkScrollPosition() {
      const scrollPosition = rightSidePanel.scrollTop + rightSidePanel.clientHeight;
      const scrollHeight = rightSidePanel.scrollHeight;
      
      // Consider "bottom" when within 5px of actual bottom to account for rounding errors
      isRightPanelScrolledToBottom = (scrollHeight - scrollPosition) <= 5;
      
      // Consider "top" when scrollTop is 0
      isRightPanelScrolledToTop = rightSidePanel.scrollTop === 0;
      
      return {
        isAtTop: isRightPanelScrolledToTop,
        isAtBottom: isRightPanelScrolledToBottom
      };
    }
    
    // Initial check
    checkScrollPosition();
    
    // Add scroll event listener to the right panel to update state
    rightSidePanel.addEventListener('scroll', function() {
      checkScrollPosition();
    });
    
    // Intercept wheel events on the ENTIRE document
    document.addEventListener('wheel', function(event) {
      // Only handle vertical scrolling
      if (event.deltaY === 0) return;
      
      const scrollState = checkScrollPosition();
      
      // Scrolling down
      if (event.deltaY > 0) {
        // If not at bottom, prevent page scroll and scroll the panel instead
        if (!scrollState.isAtBottom) {
          event.preventDefault();
          rightSidePanel.scrollTop += event.deltaY;
        }
        // If at bottom, allow normal page scrolling (do nothing)
      }
      // Scrolling up
      else if (event.deltaY < 0) {
        // If not at top, prevent page scroll and scroll the panel instead
        if (!scrollState.isAtTop) {
          event.preventDefault();
          rightSidePanel.scrollTop += event.deltaY;
        }
        // If at top, allow normal page scrolling (do nothing)
      }
    }, { passive: false }); // passive: false is required to use preventDefault
    
    console.log('Product scroll behavior initialized - desktop mode');
  } else if (rightSidePanel && isMobile) {
    // On mobile, implement step navigation
    setupMobileNavigation();
    console.log('Mobile device detected - step navigation initialized');
  }
  
  // Function to set up mobile navigation
  function setupMobileNavigation() {
    // Get all toggle sections
    const toggleSections = document.querySelectorAll('.toggle');
    const totalSteps = toggleSections.length;
    
    // Update total steps display
    const totalStepElement = document.getElementById('total-step');
    if (totalStepElement) {
      totalStepElement.textContent = totalSteps;
    }
    
    // Get navigation buttons
    const prevButton = document.getElementById('previous');
    const nextButton = document.getElementById('next');
    const currentStepElement = document.getElementById('current-step');
    
    // Make mobile navigation visible
    const mobileIcon = document.querySelector('.mobile__icon');
    if (mobileIcon) {
      mobileIcon.style.display = 'flex';
    }
    
    // Set initial state
    let currentStep = 0;
    
    // First, hide all sections and then show only the active one
    function hideAllSections() {
      toggleSections.forEach(section => {
        section.style.display = 'none';
        section.classList.remove('activee');
      });
    }
    
    // Initialize the view
    hideAllSections();
    if (toggleSections[currentStep]) {
      toggleSections[currentStep].style.display = 'block';
      toggleSections[currentStep].classList.add('activee');
    }
    
    // Update current step display
    if (currentStepElement) {
      currentStepElement.textContent = currentStep + 1;
    }
    
    // Enable scrolling on the right panel for mobile
    if (rightSidePanel) {
      rightSidePanel.style.overflowY = 'auto';
    }
    
    // Add event listeners to navigation buttons
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentStep > 0) {
          currentStep--;
          updateVisibleSection();
        }
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        if (currentStep < totalSteps - 1) {
          currentStep++;
          updateVisibleSection();
        }
      });
    }
    
    // Function to update visible section
    function updateVisibleSection() {
      // Hide all sections first
      hideAllSections();
      
      // Show only the current section
      if (toggleSections[currentStep]) {
        toggleSections[currentStep].style.display = 'block';
        toggleSections[currentStep].classList.add('activee');
      }
      
      // Update current step display
      if (currentStepElement) {
        currentStepElement.textContent = currentStep + 1;
      }
      
      // Show discount code section on mobile when step 8 is reached (index 7)
      const discountSection = document.querySelector('.discount-code-section-desktop');
      if (discountSection && currentStep >= 7) {
        discountSection.classList.add('show-on-mobile');
      } else if (discountSection) {
        discountSection.classList.remove('show-on-mobile');
      }
      
      // Scroll to top of the section
      if (rightSidePanel) {
        rightSidePanel.scrollTop = 0;
      }
      
      // Update button states
      if (prevButton) {
        prevButton.style.opacity = currentStep === 0 ? '0.5' : '1';
        prevButton.style.pointerEvents = currentStep === 0 ? 'none' : 'auto';
      }
      
      if (nextButton) {
        nextButton.style.opacity = currentStep === totalSteps - 1 ? '0.5' : '1';
        nextButton.style.pointerEvents = currentStep === totalSteps - 1 ? 'none' : 'auto';
      }
    }
    
    // Initial update of button states
    if (prevButton) {
      prevButton.style.opacity = '0.5'; // Disabled initially
      prevButton.style.pointerEvents = 'none'; // Prevent clicks when disabled
    }
    
    if (nextButton && totalSteps > 1) {
      nextButton.style.opacity = '1'; // Enabled if there are more steps
    }
    
    // Add step navigation to the step numbers themselves
    const stepNumbers = document.querySelectorAll('.step_num');
    stepNumbers.forEach((stepNum, index) => {
      // Make step numbers clickable
      stepNum.style.cursor = 'pointer';
      stepNum.addEventListener('click', function() {
        currentStep = index;
        updateVisibleSection();
      });
    });
  }
});
